import SaveButton from '@pages/partners-registration/footer/SaveButton';



interface FooterProps {
	scrollToTop: () => void
}


const Footer = (props: FooterProps) => {
	const { scrollToTop } = props;
	
	return (
		<div className='footer-section'>

			<SaveButton scrollToTop={scrollToTop} />
			
		</div>
	);
};

export default Footer;